import React, { Fragment, useEffect, useRef, useState } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ModMessageChatItemMini from "./ModMessageChatItemMini";

const MiniModChat = ({
  profile,
  auth: { user, isAuthenticated },
  modmessages,
  modmessage,
  setModMessage,
  deleteModMessage,
  TimeOutMod,
  timeoutDeleteModMessage,
  showModGIFs,
  setShowModGifs,
  gifSearch,
  setModGifSearch,
  sendModMessage,
  gifs,
  setModGif,
  foundModGif,
  filterModText,
  setFilterModText,
  getGifsSearch,
  setShowMiniModChat,
  setShowMiniChat,
  timeoutUser,
  unTimeoutUser,
  setReportUserOpen,
  setShowReportUser,
  setReportedUser,
  moderators,
  deleteModerator,
  viewerCount,
  maxLength,
  banDeleteMessage,
  Ban,
  moderate,
  setShowBanUser,
  setBannedUser,
}) => {
  const inputRef = useRef(null);

  const [mention, setMention] = useState(false);

  const [str, setStr] = useState(" ");

  function checkWord(word) {
    if (word) {
      word.split(" ").map((x) => {
        if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
          setMention(true);
        } else {
          setMention(false);
        }
      });
    }
  }

  function addMention(e, modmessage) {
    let messageArray = modmessage.split(" ");
    messageArray.pop();
    messageArray.push(e.currentTarget.attributes.value.value);
    setModMessage(messageArray.join(" ").toString());
    setMention(false);
  }

  useEffect(() => {
    checkWord(modmessage);
  }, [modmessage]);

  useEffect(() => {
    if (modmessage) {
      modmessage.split(" ").map((x) => {
        if (x[0] === "@" && x[1] !== "?" && !/\s/.test(x)) {
          setStr(x);
        }
      });
    }
  }, [modmessage]);

  return (
    <Fragment>
      <div className="mini-live-stream-side-container">
        {user.channelid === "roland" && isAuthenticated && (
          <div className="container-name">
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowMiniModChat(true);
                setShowMiniChat(false);
              }}
            >
              <i className="fas fa-users-cog red mr-5"></i>Mods
              <i className="far fa-check-circle red fa-sm mx-5"></i>
            </p>
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowMiniChat(true);
                setShowMiniModChat(false);
              }}
            >
              <i className="far fa-comments red mr-5"></i>Chat
            </p>
          </div>
        )}
        {user && user.channelid !== "roland" && (
          <div className="container-name">
            {moderators &&
              moderators.length > 0 &&
              moderators.map((mod) => {
                if (mod.channelid === user.channelid) {
                  return (
                    <p
                      className="container-title cursor red"
                      onClick={() => {
                        setShowMiniModChat(true);
                        setShowMiniChat(false);
                      }}
                    >
                      <i className="fas fa-users-cog red mr-5"></i>Mods
                    </p>
                  );
                }
              })}
            <p
              className="container-title cursor red"
              onClick={() => {
                setShowMiniChat(true);
                setShowMiniModChat(false);
              }}
            >
              <i className="far fa-comments red mr-5"></i>Chat
              <i className="far fa-check-circle red fa-sm mx-5"></i>
            </p>
          </div>
        )}
        {user.channelid === "roland" && (
          <div className="chat-search">
            <input
              type="text"
              className="gif-input"
              name="text"
              value={filterModText}
              onChange={(e) => setFilterModText(e.target.value)}
              placeholder="Search for messages..."
            />
            <i className="fas fa-search magnifying red fa-lg cursor"></i>
          </div>
        )}
        <ScrollToBottom className="all-content-mini">
          {filterModText !== "" && modmessages && modmessages.length > 0
            ? modmessages
                .filter((modmessage) => {
                  return (
                    modmessage.firstname.toLowerCase().match(filterModText) ||
                    modmessage.text.toLowerCase().match(filterModText) ||
                    modmessage.firstname.match(filterModText) ||
                    modmessage.text.match(filterModText)
                  );
                })
                .map((modmessage, index) => {
                  return (
                    <ModMessageChatItemMini
                      key={index}
                      user={user}
                      modmessage={modmessage}
                      modmessages={modmessages}
                      deleteModMessage={deleteModMessage}
                      isAuthenticated={isAuthenticated}
                      profile={profile}
                      TimeOutMod={TimeOutMod}
                      setShowReportUser={setShowReportUser}
                      setReportedUser={setReportedUser}
                      setShowBanUser={setShowBanUser}
                      setBannedUser={setBannedUser}
                      moderators={moderators}
                      moderate={moderate}
                      deleteModerator={deleteModerator}
                      timeoutDeleteModMessage={timeoutDeleteModMessage}
                      banDeleteMessage={banDeleteMessage}
                      Ban={Ban}
                      timeoutUser={timeoutUser}
                      unTimeoutUser={unTimeoutUser}
                      setReportUserOpen={setReportUserOpen}
                    />
                  );
                })
            : modmessages &&
              modmessages.map((modmessage, index) => (
                <ModMessageChatItemMini
                  key={index}
                  user={user}
                  modmessage={modmessage}
                  modmessages={modmessages}
                  deleteModMessage={deleteModMessage}
                  isAuthenticated={isAuthenticated}
                  profile={profile}
                  TimeOutMod={TimeOutMod}
                  setShowReportUser={setShowReportUser}
                  setReportedUser={setReportedUser}
                  setShowBanUser={setShowBanUser}
                  setBannedUser={setBannedUser}
                  moderators={moderators}
                  moderate={moderate}
                  deleteModerator={deleteModerator}
                  timeoutDeleteModMessage={timeoutDeleteModMessage}
                  banDeleteMessage={banDeleteMessage}
                  Ban={Ban}
                  timeoutUser={timeoutUser}
                  unTimeoutUser={unTimeoutUser}
                  setReportUserOpen={setReportUserOpen}
                />
              ))}
        </ScrollToBottom>
        {user && user.role !== "employer" && (
          <div>
            {isAuthenticated &&
              !user.banned &&
              !user.timed_out &&
              user.founding_supporter_type !== "Good" && (
                <div className="chat-message-container-mini">
                  {mention && (
                    <div className="room-users-container">
                      <div className="room-users-mini">
                        <ul>
                          {viewerCount &&
                            viewerCount
                              .filter((y) => {
                                return y.channelid.match(str.substring(1));
                              })
                              .map((c) => {
                                if (c.channelid !== "") {
                                  return (
                                    <li
                                      onClick={(e) => {
                                        addMention(e, modmessage);
                                        inputRef.current.focus();
                                      }}
                                      className={`room-user-item ${
                                        c.role === "innovator"
                                          ? "green"
                                          : c && c.role === "mentor"
                                          ? "red"
                                          : c && c.role === "employer"
                                          ? "blue"
                                          : ""
                                      } bold`}
                                      value={`@${c.channelid}`}
                                    >
                                      @{c.channelid}
                                    </li>
                                  );
                                }
                              })}
                        </ul>
                      </div>
                    </div>
                  )}
                  <div className="comment-reply-input-hidden">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                        user && user.avatar
                      }`}
                      className="chat-avi-user"
                      alt="avatar"
                    />
                    <input
                      className="comment-reply-input"
                      type="text"
                      value={modmessage}
                      ref={inputRef}
                      onChange={(e) => setModMessage(e.target.value)}
                      maxLength={100}
                      onKeyPress={(e) => {
                        if (
                          modmessage.length <= maxLength &&
                          e.key === "Enter"
                        ) {
                          sendModMessage(e);
                        }
                      }}
                      placeholder="Type your message here..."
                    />
                    {isAuthenticated &&
                      user.founding_supporter_type !== "Good" &&
                      user.founding_supporter_type !== "" && (
                        <div
                          className={`gif-button-container ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                          onClick={() => setShowModGifs(true)}
                        >
                          <p className="gif-button">GIF</p>
                        </div>
                      )}
                    <p className="white character-counter-comment">
                      {modmessage.length}/{maxLength} characters
                    </p>
                  </div>
                </div>
              )}
            {isAuthenticated && user.banned && (
              <div className="chat-message-container-mini">
                <div className="comment-reply-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <div className="user-banned-alt red">
                    <i className="fa-solid fa-ban mr-5 fa-lg red"></i>Banned
                  </div>
                </div>
              </div>
            )}
            {isAuthenticated && user.timed_out && (
              <div className="chat-message-container-mini">
                <div className="comment-reply-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <div className="user-banned-alt red">
                    <i className="fa-solid fa-clock mr-5 fa-lg red"></i>
                    Timed Out
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

MiniModChat.propTypes = {
  auth: PropTypes.object.isRequired,
  getGifs: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
});

export default connect(mapStateToProps, {})(MiniModChat);
